module.exports = __webpack_public_path__ + "static/media/uncheckedicon.af5d73c6.svg";